// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CoffeeComponent} from './Coffee.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCoffee = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CoffeeComponent/>
  </Icon>
));
